/**
 * Embalagem de presente e troca da variante do brinde.
 * Os dois precisam da API do carrinho: o interruptor adiciona ou remove o produto,
 * e a variante escolhida substitui a que entrou automaticamente.
 */
(function () {
  if (window.__elazGiftActionsInstalled) return;
  window.__elazGiftActionsInstalled = true;

  var WRAP = '_elaz_gift_wrap';
  var PRIZE = '_elaz_prize';
  var CHOSEN = '_elaz_variant_chosen';

  function cartUrl(path) {
    var routes = window.routes || {};
    var root = routes.root_url || '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function refreshCartSurfaces() {
    var updates = [];
    ['cart-drawer', 'cart-page'].forEach(function (name) {
      document.querySelectorAll(name).forEach(function (element) {
        if (typeof element.update === 'function') updates.push(element.update());
      });
    });
    return Promise.all(updates);
  }

  function giftQuickRoot() {
    var root = document.getElementById('elaz-gift-quick-root');
    if (root) return root;
    root = document.createElement('div');
    root.id = 'elaz-gift-quick-root';
    document.body.appendChild(root);
    return root;
  }

  function liftGiftModal(id) {
    var clean = String(id || '').replace(/^#/, '');
    if (clean.indexOf('GiftQuickBuy') !== 0) return;
    var nodes = Array.prototype.filter.call(
      document.querySelectorAll('modal-component.cart-gift-quick'),
      function (node) { return node.id === clean; }
    );
    if (!nodes.length) return;
    var fresh = null;
    nodes.forEach(function (node) {
      if (!node.closest('#elaz-gift-quick-root')) fresh = node;
    });
    var modal = fresh || nodes[0];
    nodes.forEach(function (node) {
      if (node !== modal) node.remove();
    });
    var root = giftQuickRoot();
    if (modal.parentElement !== root) root.appendChild(modal);
  }

  async function readCart() {
    var response = await fetch(cartUrl('cart.js'), { headers: { Accept: 'application/json' } });
    if (!response.ok) return null;
    return response.json();
  }

  async function toggleWrap(button) {
    if (button.dataset.busy === 'true') return;
    var variantId = Number(button.dataset.variantId);
    if (!variantId) return;
    button.dataset.busy = 'true';
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
    var on = button.getAttribute('aria-checked') === 'true';
    button.setAttribute('aria-checked', on ? 'false' : 'true');

    try {
      var cart = await readCart();
      if (!cart) {
        button.setAttribute('aria-checked', on ? 'true' : 'false');
        return;
      }
      var keys = [];
      (cart.items || []).forEach(function (item) {
        var marker = item.properties && item.properties[WRAP];
        if (marker && item.variant_id === variantId) keys.push(item.key);
      });

      if (on) {
        await Promise.all(keys.map(function (key) {
          var body = new FormData();
          body.append('id', key);
          body.append('quantity', '0');
          return fetch(cartUrl('cart/change.js'), {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: body
          });
        }));
      } else if (!keys.length) {
        var properties = {};
        properties[WRAP] = '1';
        await fetch(cartUrl('cart/add.js'), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1, properties: properties }]
          })
        });
      }

      await refreshCartSurfaces();
    } catch (error) {
      button.setAttribute('aria-checked', on ? 'true' : 'false');
    } finally {
      button.dataset.busy = 'false';
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
    }
  }

  async function replaceGiftLine(picker, variantId) {
    if (!picker || picker.dataset.busy === 'true' || !variantId) return false;
    picker.dataset.busy = 'true';
    window.__elazGiftVariantChanging = true;
    window.__elazGiftChoice = {
      sourceProductId: picker.dataset.sourceProduct || '',
      variantId: String(variantId)
    };
    try {
      var properties = {};
      properties[CHOSEN] = '1';
      if (picker.dataset.keepPrize === '1') properties[PRIZE] = '1';
      if (picker.dataset.sourceProduct) properties._elaz_prize_source = picker.dataset.sourceProduct;
      if (picker.dataset.giftId) {
        properties['Gift ID '] = picker.dataset.giftId;
        properties['Gift ID'] = picker.dataset.giftId;
      }

      var added = await fetch(cartUrl('cart/add.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{
            id: Number(variantId),
            quantity: 1,
            properties: properties
          }]
        })
      });
      if (!added.ok) return false;

      var body = new FormData();
      body.append('id', picker.dataset.lineKey);
      body.append('quantity', '0');
      var removed = await fetch(cartUrl('cart/change.js'), {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      });
      return removed.ok;
    } catch (error) {
      return false;
    } finally {
      window.__elazGiftVariantChanging = false;
      picker.dataset.busy = 'false';
    }
  }

  function giftDialog(node) {
    return node && node.closest ? node.closest('[data-gift-variant-picker]') : null;
  }

  function setGiftReady(dialog, ready) {
    var add = dialog.querySelector('[data-gift-add]');
    if (!add) return;
    add.disabled = !ready;
    add.classList.toggle('is-ready', ready);
    add.textContent = ready ? add.dataset.labelReady : add.dataset.labelWait;
  }

  function selectGiftColor(dialog, dot) {
    var color = dot.dataset.giftColorValue;
    var productId = dot.dataset.giftProductId || '';
    dialog.querySelectorAll('[data-gift-color-dot]').forEach(function (button) {
      var on = productId
        ? button.dataset.giftProductId === productId
        : button.dataset.giftColorValue === color;
      button.classList.toggle('is-selected', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var photo = dialog.querySelector('[data-gift-photo]');
    if (photo && dot.dataset.giftImage) photo.src = dot.dataset.giftImage;
    var title = dialog.querySelector('[data-gift-title]');
    if (title && dot.dataset.giftTitle) title.textContent = dot.dataset.giftTitle;
    var details = dialog.querySelector('[data-gift-details]');
    if (details && dot.dataset.giftUrl) details.href = dot.dataset.giftUrl;
    var price = dialog.querySelector('[data-gift-price]');
    var compare = dialog.querySelector('[data-gift-compare]');
    var discount = dialog.querySelector('[data-gift-discount]');
    if (price && dot.dataset.price) price.textContent = dot.dataset.price;
    if (compare) {
      compare.hidden = !dot.dataset.compare;
      compare.textContent = dot.dataset.compare || '';
    }
    if (discount) {
      var percent = Number(dot.dataset.discount) || 0;
      discount.hidden = percent < 1;
      discount.textContent = percent > 0 ? '-' + percent + '%' : '';
    }
    var colorName = dialog.querySelector('[data-gift-color-name]');
    if (colorName) colorName.textContent = color;
    dialog.querySelectorAll('[data-gift-size]').forEach(function (size) {
      var show = productId
        ? size.dataset.giftProductId === productId
        : (!color || size.dataset.giftColorValue === color);
      size.hidden = !show;
      size.classList.remove('is-selected');
      size.setAttribute('aria-pressed', 'false');
    });
    setGiftReady(dialog, false);
  }

  function selectGiftSize(dialog, size) {
    dialog.querySelectorAll('[data-gift-size]').forEach(function (button) {
      var on = button === size;
      button.classList.toggle('is-selected', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var price = dialog.querySelector('[data-gift-price]');
    var compare = dialog.querySelector('[data-gift-compare]');
    var discount = dialog.querySelector('[data-gift-discount]');
    if (price) price.textContent = size.dataset.price || '';
    if (compare) {
      compare.hidden = !size.dataset.compare;
      compare.textContent = size.dataset.compare || '';
    }
    if (discount) {
      var percent = Number(size.dataset.discount) || 0;
      discount.hidden = percent < 1;
      discount.textContent = percent > 0 ? '-' + percent + '%' : '';
    }
    setGiftReady(dialog, size.dataset.available === 'true');
  }

  async function chooseGiftVariant(picker) {
    if (picker.dataset.busy === 'true') return;
    var selects = picker.querySelectorAll('[data-gift-option-index]');
    var chosen = [];
    for (var i = 0; i < selects.length; i += 1) {
      if (!selects[i].value) return;
      chosen.push(selects[i].value);
    }

    var mapNode = picker.querySelector('[data-gift-variant-map]');
    if (!mapNode) return;
    var variants = [];
    try {
      variants = JSON.parse(mapNode.textContent || '[]');
    } catch (error) {
      return;
    }

    var match = null;
    variants.forEach(function (variant) {
      if (match || !variant.available) return;
      var options = variant.options || [];
      var same = options.length === chosen.length;
      options.forEach(function (option, index) {
        if (option !== chosen[index]) same = false;
      });
      if (same) match = variant;
    });
    if (!match) return;

    picker.dataset.busy = 'true';
    window.__elazGiftVariantChanging = true;
    try {
      var properties = {};
      properties[CHOSEN] = '1';
      if (picker.dataset.keepPrize === '1') properties[PRIZE] = '1';
      if (picker.dataset.sourceProduct) properties._elaz_prize_source = picker.dataset.sourceProduct;
      if (picker.dataset.giftId) {
        properties['Gift ID '] = picker.dataset.giftId;
        properties['Gift ID'] = picker.dataset.giftId;
      }

      await fetch(cartUrl('cart/add.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{
            id: match.id,
            quantity: 1,
            properties: properties
          }]
        })
      });

      var body = new FormData();
      body.append('id', picker.dataset.lineKey);
      body.append('quantity', '0');
      await fetch(cartUrl('cart/change.js'), {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      });

      refreshCartSurfaces();
    } finally {
      window.__elazGiftVariantChanging = false;
      picker.dataset.busy = 'false';
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-gift-wrap-toggle]');
    if (!button) return;
    event.preventDefault();
    toggleWrap(button);
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-gift-option-index]');
    if (!select) return;
    var picker = select.closest('[data-gift-variant-picker]');
    if (picker) chooseGiftVariant(picker);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || (form.id !== 'CartDrawerForm' && form.id !== 'CartPageForm')) return;
    if (document.querySelector('[data-gift-pending], [data-gift-variant-picker] select option[value=""]:checked')) {
      event.preventDefault();
    }
  });

  document.addEventListener('click', function (event) {
    var dot = event.target.closest('[data-gift-color-dot]');
    if (dot) {
      var colorDialog = giftDialog(dot);
      if (colorDialog) selectGiftColor(colorDialog, dot);
      return;
    }

    var size = event.target.closest('[data-gift-size]');
    if (size && size.dataset.available === 'true') {
      var sizeDialog = giftDialog(size);
      if (sizeDialog) selectGiftSize(sizeDialog, size);
      return;
    }

    var add = event.target.closest('[data-gift-add]');
    if (add && !add.disabled && add.dataset.busy !== 'true') {
      var addDialog = giftDialog(add);
      var selected = addDialog && addDialog.querySelector('[data-gift-size][aria-pressed="true"]');
      if (!addDialog || !selected) return;
      add.dataset.busy = 'true';
      add.classList.add('is-loading');
      add.setAttribute('aria-busy', 'true');
      replaceGiftLine(addDialog, selected.dataset.variantId).then(function (ok) {
        add.dataset.busy = 'false';
        add.classList.remove('is-loading');
        add.removeAttribute('aria-busy');
        if (!ok) return;
        var modal = addDialog.closest('modal-component');
        if (modal && typeof modal.hide === 'function') modal.hide();
        refreshCartSurfaces();
      });
      return;
    }
  });

  function liftGiftModalFromOpener(event) {
    var opener = event.target.closest && event.target.closest('[data-modal]');
    if (!opener || (opener.getAttribute('data-action') || 'open') === 'close') return;
    liftGiftModal(opener.getAttribute('data-modal'));
  }

  document.addEventListener('click', liftGiftModalFromOpener, true);
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    liftGiftModalFromOpener(event);
  }, true);

  var giftQuickObserver = new MutationObserver(function (records) {
    records.forEach(function (record) {
      var modal = record.target;
      if (!modal.classList || !modal.classList.contains('cart-gift-quick') || !modal.classList.contains('is-opened')) return;
      if (!modal.closest('#elaz-gift-quick-root')) giftQuickRoot().appendChild(modal);
    });
  });
  giftQuickObserver.observe(document.documentElement, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class']
  });
})();
